function initTranslateButton() {
  if (document.getElementById('quick-translate-btn')) return;

  // Create the translate button element
  const translateBtn = document.createElement('a');
  translateBtn.id = 'quick-translate-btn';
  translateBtn.target = '_blank';
  translateBtn.rel = 'noopener noreferrer';
  
  // Globe SVG icon
  const globeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/></svg>`;
  
  translateBtn.innerHTML = globeIcon + '<span>Translate</span>';
  document.body.appendChild(translateBtn);

  let hideTimeout;

  // Function to show the button
  function showTranslateButton(e) {
    const selection = window.getSelection();
    const text = selection.toString().trim();

    // Only show for meaningful text (> 1 character)
    if (text.length > 1) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();

      // Ensure the selection is actually visible (not a hidden element)
      if (rect.width > 0 && rect.height > 0) {
        // Calculate position above the selection
        const top = rect.top + window.scrollY - 36; // 36px above
        const left = rect.left + window.scrollX + (rect.width / 2);

        // Prevent it from going off the top of the screen
        const finalTop = Math.max(10, top);

        translateBtn.style.top = finalTop + 'px';
        translateBtn.style.left = left + 'px';
        
        // Build the translate URL. 'sl=auto' automatically detects source language.
        const encodedText = encodeURIComponent(text);
        translateBtn.href = `https://translate.google.com/?sl=auto&text=${encodedText}&op=translate`;

        translateBtn.classList.add('show');
      }
    } else {
      hideTranslateButton();
    }
  }

  function hideTranslateButton() {
    translateBtn.classList.remove('show');
  }

  // Listen for mouseup and touchend
  function handleSelection(e) {
    if (e.target.closest('#quick-translate-btn')) return;
    
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      const selection = window.getSelection();
      const text = selection ? selection.toString().trim() : '';
      console.log("Quick Translate: Selection detected, length:", text.length);
      
      if (text.length > 1) {
        showTranslateButton(e);
      } else {
        hideTranslateButton();
      }
    }, 50);
  }

  document.addEventListener('mouseup', handleSelection);
  document.addEventListener('touchend', handleSelection);

  document.addEventListener('selectionchange', function() {
    const selection = window.getSelection();
    if (!selection || selection.toString().trim().length <= 1) {
      hideTranslateButton();
    }
  });
  
  window.addEventListener('scroll', function() {
    hideTranslateButton();
  }, { passive: true });
}

// Ensure the script runs regardless of how it's loaded (defer/async)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTranslateButton);
} else {
  initTranslateButton();
}
